module.exports = __webpack_public_path__ + "static/hiredjimg-c5402587b10374d6a3381983cb852e40.jpg";